// Convert "can_view" → "View"
const formatPermissionKey = (key) => {
  return key
    .replace("can_", "") // remove prefix
    .replace("_", " ") // replace underscore
    .replace(/\b\w/g, (c) => c.toUpperCase()); // Capitalize
};

// Convert "dashboard" → "Dashboard"
const formatModuleName = (module) => {
  return module.replace(/\b\w/g, (c) => c.toUpperCase());
};

// Build readable permission string
export const formatPermissions = (permissions) => {
  if (!permissions || permissions.length === 0) return "—";

  return permissions
    .map((item) => {
      const moduleName = formatModuleName(item.module);
      const perms = item.permissions.map(formatPermissionKey).join(", ");

      return `${moduleName}: ${perms}`;
    })
    .join(" | ");
};

export const hasAtLeastOneViewPermission = (permissions, selected) => {
  return permissions?.some((module) =>
    selected[module.module]?.some((permKey) =>
      permKey.toLowerCase().includes("view")
    )
  );
};
